function postMessage(action){

  // 發送消息給父頁面，data為對象
  parent.postMessage( { msg : action}, '*' );

}

export {postMessage}
  
    // 接收父頁面的訊息 start -----------------------------------------------------
    
    //回調函數
    // function receiveMessageFromIndex ( event ) {
    //   // console .log( 'receiveMessageFromIndex' , event )
    //   console .log( 'receiveMessageFromIndex' , event )
    // }
    // //監聽message事件
    // window .addEventListener( "message" , receiveMessageFromIndex, false );

    // window.addEventListener('message', function(event) {
    //   // IMPORTANT: Check the origin of the data!
    //       console.log(event.data);
    //   if (~event.origin.indexOf('http://yoursite.com')) {
    //       // The data has been sent from your site
    //       // The data sent with postMessage is stored in event.data
    //       console.log(event.data);
    //   } else {
    //       // The data hasn't been sent from your site!
    //       // Be careful! Do not use it.
    //       return;
    //   }
    // });
    // 接收父頁面的訊息 end -----------------------------------------------------


// WEBPACK FOOTER //
// ./src/pages/js/postMessage.js